import { TechUseCaseIcon3D, TechUseCaseIconBuilding } from '@assets/images/technology/common';
import { IconBattery, IconCar, IconChartInv, IconHeart, IconHome, IconRulerInv, IconTagInv } from '@assets/images/icon';
import video from '@src/assets/images/solution/manufacturingProcess/video/rtlsVideo.mp4';
export default {
  seo: {
    title: 'Digital Twin là gì? | Nền tảng chuyên về Digital Twin',
    desc: 'Digital Twin là công nghệ thu thập dữ liệu thực tế theo thời gian thực và phản ánh chính xác trên mô hình ảo. Dữ liệu này được lưu trữ và phân tích trên nền tảng đám mây, tạo ra nhiều thông tin giá trị.',
    keywords: 'digital twin, chuyển đổi số, digital twin, tòa nhà thông minh, thực tế ảo, rtls, định vị, beacon, orbro, 오브로, Kong-tech',
    img: 'https://lh3.googleusercontent.com/fife/APg5EOYh9aOqkd00fKa4XLU2K8XNNXsW-hlEXH4NtB_sUseruIY4e9Bkzcz5ndnxOuKaLUc9lYLTSWYL4iES_8aAgOByVsue7toQpeIQlLIWRfBuSMQIGkoc53B9l90YjGlN2shwlaPtIrDkfxRVGIAXds8dga3dJZlnA3YUrD4TWi72j7S3HrpXdfJ6jxjgNiLo2i9-apXr8f1RM_1hFFPjMHSxeGbMdmKvqeU8ZuiuHi2Rsw2x5J62F2ni9sgjVLy3Uab-a1g8XkfcGHpuTi3c7cU4nJtiw-M2W7Q1TKkrFEYYW2Xm_FEwwEM3afo6934PgYkQ93BGZFCXm8BrSP0S7hdafO7oVIJ_N_4YWo97thiweofjssKRhYiKUSN43xg1B_PVwoovVcUWCMUvu6PMa_4tlX3UmHPQuBAiNcWsaQXWpUJsjZ_exvU0NeiX24Zo0PpHYleSklyMRuucH_orx1pxcuV_iSFWzvhsUCTk6SPeMNJZjuJh0DzYK9uHX1bzgpyIslvDLQnuUNObMy_laqHzk-y95TkQVtzcgLasj-E4TPfGnF-xATzL1cwzoL0wpghsJFbOfiaZxa-Mtkw_osdEVfieHqjW6AYM-Tx1u48S6WrG_TyOuUMQvZ4RDREspVX97yLnC1ublU1it5U6b3WV_RFTPaRHeDVhkGi1DYIW1XAr5zyapQ_AqDO8x0IRHGsJGnAE1fWI6XRRW-uUsCZlZGpSzHTTmAcQ3Ktq5vJq_LUINfe4_9Zj65XSizDXf6UfKCbyu5ahQXNZOIIhsXhVTYCW0TGracb_p7l2R5buSjoGxc7tNVvI9QkS3HeFMpLEFAsQADSDIusx2-JDigyRoNQgMF6IWxud2VXznSHLQXxP3VICvRXXCQCl7qNqfRdvtSoOHZ-Kfi38skS1Btj5zBmoxOgAZADxHq4wE2vK5y0pMZIvT_c7j3xTGKhmpT0XiTzhcLRWbgKszwOvByyQXWCukRjMQgsxS15GioyVRq6ZmRYHWUMRh_eI4B4VsKA12SXVbEDOETuYWZ51N6j8_CwL4kZ7LVKWlAa9-s4dgTSHDQzJv4qxdQAotcLm0cRbmn-at8Aq812zlS8BXrVA3Kv6DqfclPdPnwgg4np3i2IPtYbU7VxvhV75EfnUloa13iuEofBbQqx4x7CLdCWjbE27tyOXk8p_HaSOtYLxgOrW__l7HXdHLQNcvCIRv2lqNUpMIBAyDKGOw_LXmmU788M5a4P48DNHWIaBy_7tunMRescONY78i3ddmJY3MzMMHAnmqsNTiOAptLZv3kTv8eoGmXMGO2QPISQJZhAt9dScPcy6ujzQJz3pnbVpCPXyRb9BQuRbvSr-ScijGIF5c4TtqYCc57B39VXVRrN99dF3VbARUW4YOC1BzUbhfwjNxYsnaRCxPkrYAyV7hJfcvjeg9sFzC1B00e582ULnkQVjX4-n2tLCp1eNUryg4-_ZqmZ4qmU3iJolXpdd2Gys1sB0kjWA2Hx1JuAytbJZFaHfkX1Ij0Ya45t5y4txuyehBhw1=w2006-h1238',
    url: 'https://orbro.io/vi/enterprise/technology/what-is-digital-twin',
    type: 'website',
  },

  tag: 'Digital Twin là gì?',
  title: 'Digital Twin là gì?',
  desc: '',

  btnText: 'ORBRO Digital Twin',
  btnLink: '/vi/digital-twin',

  text: [
    {
      head: 'Digital Twin là gì?',
      desc: 'Digital Twin là công nghệ thu thập dữ liệu thực tế theo thời gian thực và phản ánh lên mô hình ảo, tái hiện chính xác hệ thống thực tế trên màn hình kỹ thuật số. Dữ liệu thu thập được lưu trữ và phân tích trên nền tảng điện toán đám mây, từ đó tạo ra nhiều thông tin giá trị. Những thông tin này hỗ trợ trong việc theo dõi trạng thái vật lý, hiệu suất, dự đoán bảo trì và các khía cạnh khác, giúp cải thiện việc ra quyết định.<br/><br/>Ví dụ, trong ngành sản xuất, Digital Twin giúp giám sát chính xác trạng thái của quy trình sản xuất và tối ưu lịch trình bảo trì thiết bị thông qua phân tích dự đoán. Điều này giúp giảm thời gian sản xuất và nâng cao chất lượng sản phẩm.<br/><br/>Digital Twin cho phép theo dõi trạng thái vận hành hệ thống thực tế theo thời gian thực, phát hiện nhanh các dấu hiệu bất thường để có biện pháp xử lý kịp thời, tăng độ ổn định của hệ thống và phòng ngừa sự cố trước khi xảy ra. Ngoài ra, Digital Twin còn cung cấp khả năng mô phỏng các kịch bản khác nhau để tìm ra phương án vận hành tối ưu, hỗ trợ việc ra quyết định chính xác và hiệu quả hơn trong việc áp dụng công nghệ mới hoặc cải tiến quy trình.<br/><br/>Digital Twin cũng được ứng dụng rộng rãi trong quản lý vòng đời sản phẩm, dự đoán bảo trì, tối ưu hiệu suất, phát triển sản phẩm, giúp doanh nghiệp tiết kiệm chi phí và nâng cao năng suất. Đây là lý do Digital Twin ngày càng trở thành công nghệ trọng yếu trong ngành công nghiệp hiện đại.',
      subHead: '',
      dot: '',
    },
    {
      video: video,
      link: 'https://orbro.io/vi/enterprise/manufacturing/process',
      head: 'Ưu điểm của Digital Twin',
      desc: '',
      subHead: [
        {
          title: 'Giám sát và phân tích thời gian thực',
          desc: 'Digital Twin thu thập và phân tích dữ liệu thời gian thực từ đối tượng vật lý để giám sát trạng thái vận hành một cách chính xác. Điều này giúp phát hiện sự cố nhanh và xử lý kịp thời, nâng cao năng suất và độ an toàn của hệ thống.',
        },
        {
          title: 'Mô phỏng và tối ưu hóa',
          desc: 'Sử dụng mô hình ảo để mô phỏng các kịch bản khác nhau và tìm phương án vận hành tối ưu, giúp giảm chi phí và tăng hiệu quả hoạt động.',
        },
        {
          title: 'Quản lý bảo trì và vòng đời',
          desc: 'Nắm bắt chính xác trạng thái vật lý để tối ưu lịch trình bảo trì và quản lý vòng đời thiết bị hiệu quả, góp phần tiết kiệm chi phí và nâng cao độ tin cậy hệ thống.',
        },
      ],
      dot: '',
    },
    {
      head: 'Các loại Digital Twin',
      desc: 'Digital Twin có thể được phân loại theo nhiều cách khác nhau tùy thuộc vào lĩnh vực công nghiệp, mục đích ứng dụng và đặc điểm của đối tượng vật lý. Dưới đây là một số loại Digital Twin tiêu biểu:',
      subHead: [
        {
          title: 'Digital Twin sản phẩm (Product Twin)',
          desc: 'Product Twin là mô hình số của một sản phẩm, sử dụng dữ liệu phát sinh trong suốt vòng đời của sản phẩm để mô phỏng trạng thái và hiệu suất hoạt động của sản phẩm đó. Trong ngành sản xuất, Product Twin được sử dụng để theo dõi và tối ưu hóa mọi giai đoạn như thiết kế, sản xuất, vận hành và bảo trì sản phẩm.',
        },
        {
          title: 'Digital Twin quy trình (Process Twin)',
          desc: 'Process Twin là mô hình số hóa các quy trình phức tạp như quy trình sản xuất hoặc vận hành cơ sở hạ tầng. Loại Digital Twin này được sử dụng để giám sát và cải thiện hiệu quả sản xuất, nâng cao hiệu suất sử dụng năng lượng và đảm bảo an toàn cho quy trình.',
        },
        {
          title: 'Digital Twin cơ sở vật chất (Facility Twin)',
          desc: 'Facility Twin là mô hình số mô phỏng đặc điểm vật lý của tòa nhà hoặc cơ sở hạ tầng. Nó cho phép theo dõi thời gian thực về mức tiêu thụ năng lượng, lịch bảo trì, các yếu tố môi trường... từ đó tối ưu hóa hiệu quả vận hành của tòa nhà.',
        },
        {
          title: 'Digital Twin thành phố (City Twin)',
          desc: 'City Twin là mô hình kỹ thuật số của cơ sở hạ tầng, giao thông và môi trường trong một thành phố. Trong mô hình thành phố thông minh, City Twin được sử dụng để tối ưu hóa luồng giao thông, nâng cao hiệu quả sử dụng năng lượng và tăng cường an toàn công cộng.',
        },
        {
          title: 'Digital Twin sinh học (Biomechanical Twin)',
          desc: 'Trong lĩnh vực y tế, Biomechanical Twin là mô hình số mô phỏng tình trạng sức khỏe của bệnh nhân dựa trên dữ liệu sinh học thu thập được. Nhờ đó, đội ngũ y tế có thể theo dõi bệnh nhân theo thời gian thực và hỗ trợ chẩn đoán một cách hiệu quả.',
        },
        {
          title: 'Digital Twin cho dịch vụ (Twin of a Service)',
          desc: 'Bên cạnh sản phẩm và quy trình, hiện nay cũng xuất hiện Digital Twin cho các dịch vụ. Loại mô hình này cho phép số hóa hoạt động và hiệu suất của dịch vụ, từ đó giúp quản lý và cải tiến dịch vụ một cách hiệu quả.',
        },
      ],
      dot: '',
    },
    {
      videoDesc: '(Click để xem Digital Twin nhà máy)',
      tag: 'noBottomLine',
      head: 'Cách thức hoạt động của công nghệ Digital Twin',
      desc: 'Digital Twin là mô hình ảo mô phỏng chính xác thế giới thực thông qua việc số hóa đối tượng vật lý. Quá trình hoạt động của Digital Twin có thể được tóm tắt qua các bước sau:',
      subHead: [
        {
          title: '1. Thu thập dữ liệu bằng cảm biến',
          desc: 'Quá trình bắt đầu bằng việc thu thập dữ liệu từ đối tượng vật lý. Các thiết bị như cảm biến, thiết bị IoT (Internet vạn vật), camera... được sử dụng để ghi lại thông tin về trạng thái, vị trí, hiệu suất hoạt động của đối tượng.',
        },
        {
          title: '2. Truyền và lưu trữ dữ liệu',
          desc: 'Dữ liệu thu thập được sẽ được truyền đến nền tảng đám mây hoặc cơ sở dữ liệu trung tâm để lưu trữ. Dữ liệu này có thể ở nhiều định dạng khác nhau, có khối lượng lớn và được cập nhật theo thời gian thực hoặc theo chu kỳ.',
        },
        {
          title: '3. Xử lý và mô hình hóa dữ liệu',
          desc: 'Dữ liệu được xử lý và phản ánh lên mô hình ảo. Trong quá trình này, có thể áp dụng các thuật toán học máy (machine learning) và các kỹ thuật phân tích dữ liệu khác để mô phỏng chính xác đặc điểm và trạng thái của đối tượng vật lý.',
        },
        {
          title: '4. Cập nhật thời gian thực',
          desc: 'Việc cập nhật dữ liệu từ cảm biến theo thời gian thực giúp mô hình Digital Twin luôn phản ánh chính xác trạng thái hiện tại của đối tượng vật lý. Nhờ đó, Digital Twin có thể phản ứng nhanh chóng với mọi thay đổi trong thế giới thực.',
        },
        {
          title: '5. Mô phỏng và tối ưu hóa',
          desc: 'Digital Twin cho phép thực hiện các mô phỏng dựa trên những kịch bản khác nhau nhằm tìm ra phương án vận hành tối ưu. Ví dụ: dự đoán hiệu suất trong điều kiện cụ thể, mô phỏng khi môi trường thay đổi để hỗ trợ ra quyết định chính xác hơn.',
        },
        {
          title: '6. Giao diện người dùng và trực quan hóa',
          desc: 'Các kết quả từ Digital Twin sẽ được hiển thị thông qua giao diện người dùng dưới dạng trực quan. Điều này giúp người dùng dễ dàng theo dõi, hiểu và nắm bắt thông tin về trạng thái, hiệu suất và dự báo liên quan đến đối tượng vật lý.<br/><br/>Thông qua các bước trên, Digital Twin tái hiện một cách chính xác thế giới thực trên không gian số, từ đó giúp nâng cao năng suất và hỗ trợ giải quyết vấn đề hiệu quả hơn.',
        },
      ],
      dot: '',
    },
    {
      tag: 'card',
      head: '',
      desc: '',
      subHead: '',
      dot: '',
    },
    {
      head: 'Phương pháp xây dựng Digital Twin',
      desc: 'Quy trình xây dựng Digital Twin có thể khác nhau tùy theo lĩnh vực công nghiệp và phạm vi ứng dụng, nhưng nhìn chung bao gồm các bước sau:',
      dot: [
        {
          title: '1. Xác định mục tiêu và phạm vi:',
          desc: [{ text: '• Xác định đối tượng vật lý nào sẽ được mô hình hóa bằng Digital Twin.' }, { text: '• Mục tiêu có thể tập trung vào việc nâng cao hiệu suất, đơn giản hóa bảo trì, mô phỏng và tối ưu hóa quy trình, v.v.' }],
        },
        {
          title: '2. Lập kế hoạch cảm biến & thu thập dữ liệu',
          desc: [{ text: '• Xác định loại cảm biến cần thiết và phương pháp thu thập dữ liệu.' }, { text: '• Lập kế hoạch thu thập dữ liệu dựa trên chu kỳ, định dạng, các yếu tố liên quan đến bảo mật và quyền riêng tư.' }],
        },
        {
          title: '3. Xây dựng hạ tầng dữ liệu',
          desc: [{ text: '• Thiết lập hạ tầng để lưu trữ và xử lý dữ liệu thu thập được.' }, { text: '• Lựa chọn và triển khai nền tảng dựa trên điện toán đám mây hoặc giải pháp tại chỗ (on-premise).' }],
        },
        {
          title: '4. Mô hình hóa và mô phỏng ảo:',
          desc: [{ text: '• Tạo mô hình ảo của đối tượng vật lý dựa trên dữ liệu thu thập được.' }, { text: '• Mô hình này phải phản ánh chính xác đặc tính của đối tượng vật lý và cho phép thử nghiệm các kịch bản khác nhau thông qua mô phỏng.' }],
        },
        {
          title: '5. Phân tích dữ liệu và huấn luyện mô hình:',
          desc: [{ text: '• Phân tích dữ liệu thu thập và áp dụng công nghệ học máy (machine learning) để cải thiện mô hình ảo.' }, { text: '• Thiết lập và huấn luyện các thuật toán nhằm dự đoán hoặc giải quyết vấn đề.' }],
        },
        {
          title: '6. Giám sát và cập nhật theo thời gian thực:',
          desc: [{ text: '• Thu thập dữ liệu theo thời gian thực từ cảm biến và cập nhật mô hình Digital Twin để phản ánh chính xác các thay đổi trong thế giới thực.' }],
        },
        {
          title: '7. Tăng cường bảo mật và bảo vệ dữ liệu cá nhân:',
          desc: [{ text: '• Thực hiện các cơ chế bảo mật để bảo vệ dữ liệu nhạy cảm.' }, { text: '• Tuân thủ các quy định và luật pháp liên quan đến quyền riêng tư.' }],
        },
        {
          title: '8. Giao diện người dùng và trực quan hóa:',
          desc: [
            { text: '• Phát triển giao diện người dùng giúp dễ dàng hiểu và theo dõi kết quả từ Digital Twin.' },
            { text: '• Sử dụng công cụ trực quan hóa để thể hiện trạng thái và hiệu suất của mô hình ảo một cách trực quan.' },
          ],
        },
        {
          title: '9. Cải tiến và tối ưu hóa liên tục:',
          desc: [{ text: '• Theo dõi hiệu suất trong quá trình vận hành và cải thiện Digital Twin khi cn thiết.' }, { text: '• Nâng cấp hệ thống thông qua việc tích hợp các nguồn dữ liệu và công nghệ mới.' }],
        },
      ],
    },
    {
      tag: 'advantage',
      head: '',
      desc: '',
      subHead: '',
      dot: '',
    },
  ],

  card: {
    title: 'Các trường hợp sử dụng Digital Twin',
    desc: 'Digital Twin đang được ứng dụng rộng rãi trong nhiều lĩnh vực công nghiệp khác nhau. Dưới đây là một số ví dụ tiêu biểu về các trường hợp sử dụng công nghệ Digital Twin:',
    cards: [
      {
        icon: TechUseCaseIcon3D,
        title: 'Digital Twin trong nhà máy sản xuất',
        desc: [
          {
            title: 'Giám sát và tối ưu thiết bị',
            desc: 'Mô hình hóa dây chuyền sản xuất và thiết bị bằng Digital Twin giúp giám sát trạng thái theo thời gian thực và tối ưu hóa lịch bảo trì thông qua phân tích dự đoán.',
          },
          {
            title: 'Phát triển và mô phỏng sản phẩm',
            desc: 'Tạo bản sao kỹ thuật số của sản phẩm để mô phỏng toàn bộ quá trình từ thiết kế đến sản xuất, từ đó tìm ra thiết kế tối ưu.',
          },
        ],
      },
      {
        icon: IconHome,
        title: 'Digital Twin xây dựng và bất động sản',
        desc: [
          {
            title: 'Giám sát công trình xây dựng',
            desc: 'Theo dõi tình trạng “sức khỏe” của tòa nhà và cơ sở hạ tầng theo thời gian thực, tối ưu hóa lịch bảo trì và nâng cao mức độ an toàn.',
          },
          {
            title: 'Lập kế hoạch và mô phỏng đô thị',
            desc: 'Mô phỏng giao thông, sử dụng năng lượng và tác động môi trường của thành phố nhằm xây dựng kế hoạch phát triển đô thị hiệu quả hơn.',
          },
        ],
      },
      {
        icon: IconBattery,
        title: 'Giải pháp quản lý năng lượng',
        desc: [
          {
            title: 'Vận hành lưới điện thông minh (Smart Grid)',
            desc: 'Mô hình hóa mạng lưới cung cấp điện bằng Digital Twin để tối ưu hóa dòng năng lượng, phát hiện và phòng tránh sự cố, nâng cao hiệu suất hệ thống điện.',
          },
          {
            title: '',
            desc: '',
          },
        ],
      },
      {
        icon: IconHeart,
        title: 'Digital Twin trong y tế',
        desc: [
          {
            title: 'Theo dõi bệnh nhân và hỗ trợ chẩn đoán',
            desc: 'Tái hiện tình trạng sức khỏe bệnh nhân qua mô hình Digital Twin giúp nhân viên y tế theo dõi thời gian thực và hỗ trợ công tác chẩn đoán.',
          },
          {
            title: 'Phát triển thiết bị y tế',
            desc: 'Ứng dụng mô phỏng bằng Digital Twin trong giai đoạn phát triển thiết bị y tế nhằm nâng cao hiệu suất và độ chính xác.',
          },
        ],
      },
      {
        icon: IconCar,
        title: 'Digital Twin trong ngành ô tô và vận tải',
        desc: [
          {
            title: 'Thiết kế và kiểm nghiệm xe',
            desc: 'Sử dụng Digital Twin trong giai đoạn phát triển xe để nâng cao hiệu suất và kiểm chứng độ an toàn thông qua mô phỏng.',
          },
          {
            title: 'Tối ưu hóa logistics và vận tải',
            desc: 'Mô hình hóa mạng lưới logistics bằng Digital Twin nhằm tối ưu quá trình vận chuyển và giảm chi phí vận hành.',
          },
        ],
      },
      {
        icon: TechUseCaseIconBuilding,
        title: 'Digital Twin trong tòa nhà thông minh (Smart Building)',
        desc: [
          {
            title: 'Hệ thống đo lường thông minh',
            desc: 'Mô hình hóa hệ thống điện, gas, nước,... bằng Digital Twin giúp giám sát theo thời gian thực và cung cấp thông tin tiêu thụ cho người dùng.',
          },
          {
            title: 'Giám sát môi trường',
            desc: 'Biểu thị trạng thái môi trường qua Digital Twin để theo dõi liên tục các yếu tố như chất lượng không khí, nước, khí hậu..., hỗ trợ ra quyết định quản lý môi trường.',
          },
        ],
      },
    ],
  },

  advantage: {
    title: 'Đặc điểm chính của Digital Twin',
    cards: [
      { 
        icon: IconRulerInv,
        title: 'Khả năng giám sát và phản ứng theo thời gian thực',
        desc: 'Digital Twin cho phép giám sát trạng thái của đối tượng vật lý trong thời gian thực, nhờ đó có thể nhanh chóng phản ứng khi phát hiện hoặc dự đoán vấn đề. Điều này đóng vai trò quan trọng trong các đối tượng như dây chuyền sản xuất, thiết bị, tòa nhà, v.v. Nhờ khả năng phản ứng nhanh, hệ thống trở nên an toàn hơn và có thể giảm thiểu các sự cố tiềm ẩn.',
      },
      {
        icon: IconTagInv,
        title: 'Chức năng mô phỏng và tối ưu hóa',
        desc: 'Digital Twin sử dụng mô hình ảo để mô phỏng nhiều kịch bản khác nhau và tìm ra phương án vận hành tối ưu. Qua đó, doanh nghiệp có thể tối đa hóa hiệu suất trong các khía cạnh như quy trình sản xuất, thiết kế sản phẩm, sử dụng năng lượng, v.v. Ngoài ra, việc mô phỏng trong môi trường thay đổi giúp đưa ra quyết định trước một cách chính xác, qua đó giảm thiểu rủi ro.',
      },
      {
        icon: IconChartInv,
        title: 'Giảm chi phí bảo trì và quản lý vòng đời',
        desc: 'Sử dụng Digital Twin giúp giám sát chính xác trạng thái của đối tượng vật lý, từ đó tối ưu hóa lịch trình bảo trì thông qua phân tích dự đoán. Việc này giúp tránh bảo trì không cần thiết và dự đoán sự cố của máy móc hoặc thiết bị để thực hiện sửa chữa hoặc thay thế một cách hiệu quả. Nhờ đó có thể giảm chi phí bảo trì tổng thể và kéo dài tuổi thọ tài sản.',
      },
    ],
  },
};
